import Axios from "axios";
import {
  SET_LC_EXCHANGE_RATE_LIST,
  UNSET_LC_EXCHANGE_RATE_LIST,
} from "@/store/mutation-types";
import { saveUpdateLcExchangeRate, getLcExchangeRateList } from "@/store/api";

const state = {
  lcExchangeRateList: [],
};

const getters = {
  getLcExchangeRateList(state) {
    return state.lcExchangeRateList;
  },
};

const mutations = {
  [SET_LC_EXCHANGE_RATE_LIST](state, data) {
    state.lcExchangeRateList = data;
  },
  [UNSET_LC_EXCHANGE_RATE_LIST](state) {
    state.lcExchangeRateList = [];
  },
};

const actions = {
  saveUpdateLcExchangeRate({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateLcExchangeRate, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getLcExchangeRateList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getLcExchangeRateList, data)
        .then(function (response) {
          commit("SET_LC_EXCHANGE_RATE_LIST", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_LC_EXCHANGE_RATE_LIST");
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

